import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class PreventPageLeave extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    // If this component is rendered in a dialog, we shouldn't block url changes.
    if (this.component.props.renderedInDialog === true) {
      return;
    }

    this.component.props.router.setRouteLeaveHook(
      this.component.props.route,
      this.component.routerWillLeave
    );
  }
}

export default new PreventPageLeave();
